import gql from 'graphql-tag';

import type { BlogContent } from 'src/data/blog';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_BLOG_CONTENT } from './schema';

const QUERY = gql`
  query ProjectBlogData($projectId: Int!, $draftIndex: ID!) {
    project(id: $projectId) {
      id

      blogContent(draftId: $draftIndex) {
        ...BlogPostBuilderContent
      }
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT}
`;

interface Params {
  projectId: number;
  draftIndex: string;
}

interface Options {
  abortSignal?: AbortSignal;
}

interface Result {
  id: ID;
  blogContent: BlogContent;
}

export const queryProjectBlogData = async (
  { projectId, draftIndex }: Params,
  options?: Options
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
      draftIndex,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<Result>(result.data);
};
